import { PriceModes } from "@components/molecules/PriceModeCard/types";
import { useCustomSearchData } from "@redux/slices/searchResultsCustomization";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { ProductCategory } from "@utils/constants";
import { SearchResultsAndFavoritesEnum } from "@utils/product/searchResultConstants";

export const getHeaderBulkOption = (
  customSearchData: any,
  productType: ProductCategory,
  priceMode: number,
  t: any
) => {
  const dataObject = customSearchData?.[productType];
  if (!dataObject?.header?.["sub-sections"]) {
    return { bulkActions: null, requestItems: null };
  }

  const bulkActionItem = dataObject.header["sub-sections"]?.bulk_action;
  if (!bulkActionItem) {
    return { bulkActions: null, requestItems: null };
  }

  const extractOptions = (section: any) =>
    Object.values(section?.options || {})
      .filter((option: any) => option?.price_modes?.includes(priceMode))
      .sort((a: any, b: any) => parseFloat(a?.order) - parseFloat(b?.order));

  const bulkActions = extractOptions(bulkActionItem);

  const requestItemOptions = extractOptions(bulkActionItem)
    .filter((item: any) => item?.name === "request_items")
    .flatMap((item: any) =>
      Object.values(item?.options || {})
        .filter((option: any) => option?.price_modes.includes(priceMode))
        .map((option: any) => ({
          ...option,
          label: t(option?.label),
        }))
    )
    .sort((a: any, b: any) => parseFloat(a?.order) - parseFloat(b?.order));

  return {
    bulkActions,
    requestItems: requestItemOptions.flat(),
  };
};

export const useHeaderBulkOption = (
  productType: ProductCategory,
  priceMode: number,
  t: any
) => {
  const customSearchData = useCustomSearchData();
  const { enableOrderCartQuote } = useUserInfo();
  const { bulkActions, requestItems } = getHeaderBulkOption(
    customSearchData,
    productType,
    priceMode,
    t
  );

  const quoteEnabled = enableOrderCartQuote() === true;
  const showSendQuote = quoteEnabled && priceMode === PriceModes.WHITE;
  const visibleBulkActions = Array.isArray(bulkActions)
    ? bulkActions.filter((action: { name?: string }) => {
        if (
          action?.name === SearchResultsAndFavoritesEnum.SEND_QUOTE &&
          !showSendQuote
        ) {
          return false;
        }
        if (
          action?.name === SearchResultsAndFavoritesEnum.BUY_NOW &&
          quoteEnabled
        ) {
          return false;
        }
        return true;
      })
    : bulkActions;

  return {
    bulkActions: visibleBulkActions,
    requestItems,
  };
};
